module.exports = __webpack_public_path__ + "img/pei1.854455a7.png";